export default __webpack_public_path__ + "static/media/saint_aubin11.afac9ec3.jpg";